import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="container mt-5" dir="rtl">
            <h1 className="text-center">سیاست حفظ حریم خصوصی</h1>
            <p>
                البرز پیمنت متعهد به حفظ حریم خصوصی شما و محافظت از اطلاعات شخصی شما است. این سیاست حریم خصوصی نحوه
                جمع‌آوری، استفاده، افشا و محافظت از اطلاعات شما را هنگام استفاده از خدمات ما، از جمله از طریق وب‌سایت ما
                (<a href="https://www.alborzpayment.com" target="_blank"
                    rel="noopener noreferrer">www.alborzpayment.com</a>)، برنامه‌های موبایل و ارتباطات با مشتری (مجموعاً
                "خدمات") شرح می‌دهد.
            </p>

            <section>
                <h2>۱. تعریف اطلاعات شخصی</h2>
                <p>
                    "اطلاعات شخصی" به معنای اطلاعات مربوط به یک فرد قابل شناسایی است، به استثنای اطلاعات تماس تجاری. این
                    شامل نام، اطلاعات تماس، شناسه صادر شده توسط دولت، جزئیات مالی و آدرس IP شما می‌شود اما محدود به این
                    موارد نیست.
                </p>
            </section>

            <section>
                <h2>۲. مبنای قانونی و رضایت</h2>
                <p>
                    با دسترسی یا استفاده از خدمات ما یا ارسال اطلاعات شخصی به ما، شما با جمع‌آوری، استفاده، افشا و
                    پردازش اطلاعات خود همانطور که در این سیاست حریم خصوصی توضیح داده شده است، موافقت می‌کنید. ما اطلاعات
                    شخصی شما را مطابق با قوانین حریم خصوصی کانادا، از جمله قانون حفاظت از اطلاعات شخصی و اسناد
                    الکترونیکی (PIPEDA) مدیریت می‌کنیم.
                </p>
            </section>

            <section>
                <h2>۳. اطلاعاتی که ما جمع‌آوری می‌کنیم</h2>
                <h3>۳.۱ اطلاعاتی که شما ارائه می‌دهید</h3>
                <ul>
                    <li>نام کامل، آدرس، ایمیل، شماره تلفن</li>
                    <li>اطلاعات مالی و پرداخت</li>
                    <li>مدارک تأیید هویت</li>
                    <li>توضیحات شخصی یا عکس‌ها (مثلاً برای انطباق KYC)</li>
                </ul>

                <h3>۳.۲ اطلاعات فنی</h3>
                <ul>
                    <li>آدرس IP، نوع دستگاه، مرورگر، سیستم عامل</li>
                    <li>زمان‌های ورود، داده‌های مکانی، تعاملات صفحه</li>
                </ul>

                <h3>۳.۳ اطلاعات از اشخاص ثالث</h3>
                <ul>
                    <li>اطلاعات هویتی و پرداخت از بانک‌ها یا پردازشگران پرداخت</li>
                    <li>داده‌های احراز هویت از ورود به شبکه‌های اجتماعی (مانند فیسبوک، گوگل)</li>
                    <li>داده‌های اعتباری و انطباق از ارائه‌دهندگان شخص ثالث</li>
                </ul>
            </section>

            <section>
                <h2>۴. استفاده از کوکی‌ها و فناوری‌های ردیابی</h2>
                <p>
                    ما از کوکی‌ها، تگ‌های پیکسل و ابزارهای تحلیلی مانند Google Analytics و Mixpanel برای موارد زیر
                    استفاده می‌کنیم:
                </p>
                <ul>
                    <li>ارائه و شخصی‌سازی خدمات</li>
                    <li>بهبود عملکرد و امنیت</li>
                    <li>اندازه‌گیری رفتار کاربر و عملکرد تبلیغات</li>
                </ul>
                <p>
                    کاربران می‌توانند ترجیحات کوکی را در تنظیمات مرورگر خود مدیریت کنند. غیرفعال کردن کوکی‌ها ممکن است
                    بر عملکرد تأثیر بگذارد.
                </p>
            </section>

            <section>
                <h2>۵. استفاده از اطلاعات شخصی</h2>
                <p>ما ممکن است از اطلاعات شخصی شما برای موارد زیر استفاده کنیم:</p>
                <ul>
                    <li>انجام درخواست‌های خدمات و پردازش تراکنش‌ها</li>
                    <li>انجام تأیید هویت (KYC/AML)</li>
                    <li>رعایت تعهدات قانونی و نظارتی</li>
                    <li>بهبود خدمات و جلوگیری از تقلب</li>
                    <li>ارسال اطلاعیه‌های اداری، تبلیغاتی یا مرتبط با خدمات (با توجه به ترجیحات شما)</li>
                </ul>
            </section>

            <section>
                <h2>۶. افشای اطلاعات شخصی</h2>
                <p>ما ممکن است اطلاعات شخصی شما را با موارد زیر به اشتراک بگذاریم:</p>
                <ul>
                    <li>
                        <strong>ارائه‌دهندگان خدمات:</strong> تأییدکنندگان KYC/AML، فروشندگان ابر و زیرساخت، پردازشگران
                        پرداخت
                    </li>
                    <li>
                        <strong>شرکای تجاری:</strong> صرافی‌هایی که برای تسهیل تراکنش‌های بین‌المللی با آنها همکاری
                        می‌کنیم
                    </li>
                    <li>
                        <strong>نهادهای قانونی و نظارتی:</strong> نیروی انتظامی، دادگاه‌ها، FINTRAC و سایر مراجع در صورت
                        درخواست قانونی
                    </li>
                    <li>
                        <strong>سایر موارد:</strong> در ارتباط با ادغام، فروش یا خرید یا هنگامی که برای اجرای سیاست‌ها
                        یا محافظت از حقوق لازم باشد
                    </li>
                </ul>
                <p>
                    نکته مهم: البرز پیمنت ممکن است با صرافی‌های شخص ثالث برای ارائه برخی خدمات همکاری کند. اگرچه ما
                    اقدامات لازم را انجام می‌دهیم، اما در قبال فعالیت‌های غیرقانونی که به طور مستقل توسط این شرکا انجام
                    می‌شود، مسئولیتی نداریم.
                </p>
            </section>

            <section>
                <h2>۷. نگهداری داده‌ها</h2>
                <p>
                    ما اطلاعات شخصی را تنها تا زمانی که برای اهداف مورد نظر لازم است و مطابق با قوانین قابل اجرا، از
                    جمله الزامات نگهداری سوابق مبارزه با پولشویی، نگه می‌داریم.
                </p>
            </section>

            <section>
                <h2>۸. امنیت</h2>
                <p>
                    ما از اقدامات امنیتی فیزیکی، فنی و سازمانی برای محافظت از داده‌های شما استفاده می‌کنیم:
                </p>
                <ul>
                    <li>سرورهای امن و رمزگذاری داده‌ها</li>
                    <li>دسترسی محدود به اطلاعات حساس</li>
                    <li>ممیزی و نظارت منظم</li>
                </ul>
                <p>
                    علی‌رغم تلاش‌های ما، هیچ سیستمی ۱۰۰٪ امن نیست. اگر به نقض امنیتی مشکوک هستید، فوراً با ما تماس
                    بگیرید.
                </p>
            </section>

            <section>
                <h2>۹. انتقال‌های فرامرزی</h2>
                <p>
                    اطلاعات شخصی شما ممکن است در کشورهای خارج از کانادا (مانند ایالات متحده) ذخیره یا پردازش شود. اگرچه
                    چنین داده‌هایی ممکن است مشمول قوانین خارجی باشند، ما از طریق تضمین‌های قراردادی و فنی، سطح مشابهی از
                    حفاظت را تضمین می‌کنیم.
                </p>
            </section>

            <section>
                <h2>۱۰. حقوق شما</h2>
                <p>شما می‌توانید:</p>
                <ul>
                    <li>درخواست دسترسی به اطلاعات شخصی خود کنید</li>
                    <li>درخواست اصلاح یا حذف کنید</li>
                    <li>رضایت خود را پس بگیرید (با توجه به محدودیت‌های قانونی یا قراردادی)</li>
                </ul>
                <p>
                    ما ممکن است برای درخواست‌ها هزینه معقولی دریافت کنیم یا درخواست‌هایی را که بیش از حد یا غیرقانونی
                    هستند رد کنیم. ممکن است برخی اطلاعات را برای انجام تعهدات قانونی نگه داریم.
                </p>
            </section>

            <section>
                <h2>۱۱. استفاده از خدمات توسط افراد زیر سن قانونی</h2>
                <p>
                    خدمات ما برای افراد زیر ۱۸ سال در نظر گرفته نشده است. ما آگاهانه اطلاعات شخصی از افراد زیر سن قانونی
                    جمع‌آوری نمی‌کنیم.
                </p>
            </section>

            <section>
                <h2>۱۲. پیوندها و برنامه‌های شخص ثالث</h2>
                <p>
                    خدمات ما ممکن است شامل پیوندهایی به وب‌سایت‌ها یا برنامه‌های خارجی باشد. ما مسئول شیوه‌های حفظ حریم
                    خصوصی آن طرف‌ها نیستیم. لطفاً سیاست‌های حریم خصوصی آنها را بررسی کنید.
                </p>
            </section>

            <section>
                <h2>۱۳. تغییرات در این سیاست</h2>
                <p>
                    ما ممکن است این سیاست حریم خصوصی را در هر زمان تجدیدنظر کنیم. تاریخ "آخرین به‌روزرسانی" در بالا
                    نشان‌دهنده آخرین نسخه است. ادامه استفاده از خدمات ما به معنای پذیرش هرگونه تغییر است.
                </p>
            </section>

            <section>
                <h2>۱۴. تماس با ما</h2>
                <p>برای سؤالات یا نگرانی‌های مربوط به این سیاست حریم خصوصی، لطفاً تماس بگیرید:</p>
                <address>
                    <strong>البرز پیمنت</strong><br/>
                    ایمیل: <a href="mailto:contact@alborzpayment.com">contact@alborzpayment.com</a><br/>
                    تلفن: ۴۶۶۶-۷۴۵ (۶۴۷) ۱+
                </address>
                <p>لطفاً اطلاعات حساس را از طریق ایمیل ارسال نکنید.</p>
            </section>
        </div>
    );
};

export default PrivacyPolicy;